module.exports = __webpack_public_path__ + "static/media/invoice-left.f8231a659349eab8d0df75a30803a281.png";